import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConfigService } from '$core/services/config.service';

export interface CookiesSettings {
  googleAnalytics: boolean;
  bitrix: boolean;
  yandexMetrica: boolean;
  googleTagManager: boolean;
}

export const COOKIES_SETTINGS_KEY = 'cookies-settings';

@Injectable({
  providedIn: 'root',
})
export class CookiesHandlingService {
  public readonly cookieSettingsPath =
    this.configService.urlByService('cookies');
  public readonly isDecisionNotMade$ = new BehaviorSubject<boolean>(false);
  public readonly selectedCookies$ = new Subject<CookiesSettings>();

  constructor(private configService: ConfigService) {}

  public checkCookiesOnInit(): void {
    const settingsFromStorage = this.getCookiesSettings();
    if (settingsFromStorage) {
      this.acceptCookies(settingsFromStorage);
    } else {
      this.isDecisionNotMade$.next(true);
    }
  }

  public getCookiesSettings(): CookiesSettings | null {
    return JSON.parse(localStorage.getItem(COOKIES_SETTINGS_KEY));
  }

  public acceptCookies(settings: CookiesSettings): void {
    localStorage.setItem(COOKIES_SETTINGS_KEY, JSON.stringify(settings));
    this.selectedCookies$.next(settings);
    this.isDecisionNotMade$.next(false);
  }

  public acceptAll(): void {
    this.acceptCookies({
      googleAnalytics: true,
      bitrix: true,
      yandexMetrica: true,
      googleTagManager: true,
    });
  }

  public declineAll(): void {
    this.acceptCookies({
      googleAnalytics: false,
      bitrix: false,
      yandexMetrica: false,
      googleTagManager: false,
    });
  }
}
